import React from 'react'
import { LuUser2 } from "react-icons/lu";
import { IoSettingsOutline } from "react-icons/io5";
import { GoOrganization } from "react-icons/go";
import { PiUsersBold } from "react-icons/pi";
import { LiaReadme } from "react-icons/lia";
import { NavLink } from "react-router-dom";

export default function LeftPanel(props) {
    return (
        <div className='leftpanel-body'>
            <ul>
                <li>
                    <NavLink to={"profile"}>
                        <span></span>
                        <div className="leftpanel-list-item">
                            <div className="list-icon"><LuUser2 /></div>
                            <div className="list-item-name">Personal Profile</div>
                        </div>
                    </NavLink>
                </li>
                <li>
                    <NavLink to={"public-profile"}>
                        <span></span>
                        <div className="leftpanel-list-item">
                            <div className="list-icon"><LiaReadme /></div>
                            <div className="list-item-name">Public Profile</div>
                        </div>
                    </NavLink>
                </li>
                <li>
                    <NavLink to={"account"}>
                        <span></span>
                        <div className="leftpanel-list-item">
                            <div className="list-icon"><IoSettingsOutline /></div>
                            <div className="list-item-name">Account</div>
                        </div>
                    </NavLink>
                </li>
                {(props.orgCode !== "vss" && props.orgCode !== "VSS") ? (
                    <li>
                        <NavLink to={"organizations"}>
                            <span></span>
                            <div className="leftpanel-list-item">
                                <div className="list-icon"><GoOrganization /></div>
                                <div className="list-item-name">Organizations</div>
                            </div>
                        </NavLink>
                    </li>
                ) : (
                    <li>
                        <NavLink to={"users"}>
                            <span></span>
                            <div className="leftpanel-list-item">
                                <div className="list-icon"><PiUsersBold /></div>
                                <div className="list-item-name">Users</div>
                            </div>
                        </NavLink>
                    </li>
                )}
                {/* <li>
                    <NavLink to={"access"}>
                    <span></span>
                    <div className="leftpanel-list-item">
                        <div className="list-icon"><LuUser2 /></div>
                        <div className="list-item-name">Accessibility</div>
                    </div>
                    </NavLink>
                </li>
                <li>
                    <NavLink to={"noti"}>
                    <span></span>
                    <div className="leftpanel-list-item">
                        <div className="list-icon"><LuUser2 /></div>
                        <div className="list-item-name">Notifications</div>
                    </div>
                    </NavLink>
                </li> */}
            </ul>
        </div>
    )
}
